<template>
  <div class="benefits">
    <div class="benefits-wrapper">
      <div class="benefits-one">
        <div class="title">
          Enhanced<span> Customer Engagement</span> and Exclusivity
        </div>
        <div class="text">
          Wecobi fosters a sense of exclusivity and engagement by involving
          customers in a dynamic campaign that requires active participation,
          making them feel like part of a special community with access to
          exclusive deals.
        </div>
      </div>
      <div class="benefits-one">
        <div class="title">Boost <span>Product Value</span> and Perception</div>
        <div class="text">
          The effort and anticipation required to secure discounted products
          through Wecobi enhance their perceived value, as customers view these
          high-quality items as more valuable compared to those offered through
          traditional discounting.
        </div>
      </div>
      <div class="benefits-three">
        <div class="title">
          Strengthen <span>Brand Loyalty</span> and Customer Retention
        </div>
        <div class="text">
          Wecobi’s approach builds stronger brand loyalty by creating positive
          emotional experiences, leading to deeper customer connections and
          longer retention of products, in contrast to traditional discounting
          that can diminish brand value and loyalty.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Benefits",
  components: {},
};
</script>

<style scoped>
.benefits {
  width: 100%;
  background: rgba(247, 247, 250, 1);
  border-radius: 20px;
  overflow: hidden;
}
.benefits-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 134px 0px;
}
.benefits-one {
  display: flex;
  flex-direction: column;
  /* max-width: 370px; */
  border-right: 4px solid rgba(238, 238, 238, 1);
  padding: 0px 50px;
}
.title {
  font-size: 25px;
  font-weight: 700;
}
.text {
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
}

span {
  color: rgba(255, 109, 10, 1);
}

.benefits-three {
  /* max-width: 370px; */
  border-right: none;
  padding: 0px 50px;
}

@media (max-width: 1280px) {
  .benefits-wrapper {
    padding: 100px 0px;
  }
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 16px;
  }
}
@media (max-width: 1024px) {
  .benefits-wrapper {
    padding: 75px 0px;
  }
  .title {
    font-size: 18px;
  }
  .text {
    font-size: 14px;
  }
}
@media (max-width: 1024px) {
  .benefits-wrapper {
    padding: 75px 0px;
  }
  .title {
    font-size: 18px;
  }
  .benefits-one,
  .benefits-three {
    padding: 0px 40px;
  }
}
@media (max-width: 744px) {
  .benefits-one,
  .benefits-three {
    padding: 0px 25px;
  }
}
@media (max-width: 588px) {
  .benefits-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px 50px;
    gap: 27px;
  }
  .benefits-one {
    width: 100%;
    border-right: none;
    border-bottom: 4px solid rgba(238, 238, 238, 1);
  }
  .benefits-one,
  .benefits-three {
    padding: 0px 0px 27px 0px;
    max-width: 450px;
  }
}
@media (max-width: 455px) {
  .benefits-wrapper {
    padding: 50px 30px;
  }

  .benefits-one,
  .benefits-three {
    max-width: 310px;
  }
}
</style>
